<template>
  <section id="quality">
    <div class="bg-offwhite w-100">
      <div class="center flex flex-wrap ph3 pt0 pb4-l pv5-xl mw9 w-100 w-80-xl">
        <!-- section heading -->
        <div class="mb4 tc w-100">
          <h2 class="f2 fw3 greyhound">Quality &amp; Reliability</h2>
        </div>
        <div class="flex flex-wrap justify-center pt4 pt5-l w-100">
          <div class="flex pa2 w-100 w-80-m w-50-l w-30-xl">
            <ul class="flex flex-column justify-between lh-double list ma0 pa0">
              <hr class="b--solid b--tan dn db-l ma0 w-100">
              <li
                data-emergence="hidden"
                class="mb4 mb0-l pr4-l">
                <h3 class="f4 f3-l fw3 greyhound ma0">Case Construction</h3>
                <p class="f6 f5-l dark-tan ma0">Rugged and durable, Pico is built for public spaces.</p>
              </li>
              <hr class="b--solid b--tan ma0 w-100">
              <li
                data-emergence="hidden"
                class="mv4 mv0-l pr4-l">
                <h3 class="f4 f3-l fw3 greyhound ma0">Made in the USA</h3>
                <p class="f6 f5-l dark-tan ma0">Pico, like all Ideum multitouch tables and displays, is proudly designed and built in the USA.</p>
              </li>
              <hr class="b--solid b--tan ma0 w-100">
              <li
                data-emergence="hidden"
                class="mv4 mv0-l pr4-l">
                <h3 class="f4 f3-l fw3 greyhound ma0">Customer Support</h3>
                <p class="f6 f5-l dark-tan ma0">All customer service requests are supported by the same team who built your Ideum multitouch table.</p>
              </li>
              <hr class="b--solid b--tan ma0 w-100">
              <li
                data-emergence="hidden"
                class="mv4 mv0-l pr4-l">
                <h3 class="f4 f3-l fw3 greyhound ma0">Three-year Warranty</h3>
                <p class="f6 f5-l dark-tan ma0">We stand by our products and provide a three-year warranty.</p>
              </li>
              <hr
                class="b--solid b--tan db-xl dn ma0 w-100"
                style="margin-bottom: .25rem">
            </ul>
          </div>
          <div class="w-100 w-50-l">
            <div class="fl pa2 w-100">
              <img
                data-src="/images/pico-base-01.jpg"
                alt="Detail image showcasing the base of the Pico touch coffee table."
                class="lazyload">
            </div>
            <div class="fl pa2 w-100 w-50-ns">
              <img
                data-src="/images/pico-top-01.jpg"
                alt="Detail image showcasing the top of the Pico touch coffee table."
                class="lazyload">
            </div>
            <div class="fl pa2 w-100 w-50-ns">
              <img
                data-src="/images/pico-top-02.jpg"
                alt="Detail image showcasing the power buttons of the Pico touch coffee table."
                class="lazyload">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionQuality'
}
</script>

<style lang="scss" scoped>
h2 {
  position: relative;
  &::after {
    background-image: url('/images/pico-hr-01.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    content: '';
    margin: auto;
    position: absolute;
    right: 0;
    bottom: -4rem;
    left: 0;
    width: 100%;
    height: 75%;
  }
}

hr {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}

li {
  padding-left: 4rem;
  position: relative;
  &::after {
    background-image: url('/images/pico-flourish-01.svg');
    background-position-y: center;
    background-repeat: no-repeat;
    background-size: contain;
    content: '';
    margin: auto 0;
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    transform-origin: left;
    width: 100%;
    height: 40px;
  }
  @media screen and (min-width: 30em) {
    padding-left: 7rem;
  }
  @media screen and (min-width: 30em) and (max-width: 60em) {
    padding-left: 5rem;
  }
}

li[data-emergence=visible] {
  &::after {
    animation: rotate-in .3s ease forwards; // defined in _animations.scss
  }
  &:nth-child(2) {
    &::after {
      animation: rotate-in .15s .3s ease forwards;
    }
  }
  &:nth-child(3) {
    &::after {
      animation: rotate-in .3s .3s ease forwards;
    }
  }
  &:nth-child(4) {
    &::after {
      animation: rotate-in .45s .3s ease forwards;
    }
  }
}
</style>
